import SolverHeader from '../../components/user/SolverHeader'
import SolverLayout from '../../components/layout/SolverLayout'
import LearningContainer from '../../components/user/LearningContainer'
import styles from '../../styles/user/Solver.module.scss'

const SolverIndividual = () => {
  return (
    <SolverLayout>
      <SolverHeader userType="general" />
      <div className={styles.solverPageWrapper}>
        <LearningContainer userType="general" />
      </div>
      {/* <img
        src="/assets/red-blue-monster.png"
        alt="monster"
        className={styles.monster}
      /> */}
    </SolverLayout>
  )
}

export default SolverIndividual
